import * as z from "zod";
import { monitoringTab } from "./monitoringAnalytics";
import { mutator } from "./mutator";

/**
 * Telemetry-only counterpart to `markMonitoringTabViewed`, covering the
 * in-page interactions that change no server state and so leave no other
 * trace. `interactionName` stays a free string rather than an enum: the
 * taxonomy is typed at the callsites, and a wire enum could never be narrowed
 * again once stale clients hold it.
 */
export const recordMonitoringInteractionSchema = z.object({
  tab: monitoringTab,
  visitId: z.string().max(64),
  interactionName: z.string().max(64),
  targetType: z.string().max(32).nullish(),
  targetId: z.string().max(128).nullish(),
  value: z.string().max(128).nullish(),
});

export const recordMonitoringInteraction = mutator({
  schema: recordMonitoringInteractionSchema,
  resolve: {},
  permissions: { none: "records that the caller clicked their own screen" },
  fn: async () => {},
});
